export const phoneNumberAutoFormat = (input: string): string => {
    const cleaned: string = input.replace(/\D/g, '')
    let formatted: string = ''

    if (cleaned.length < 4) formatted = cleaned
    else if (cleaned.length < 7) formatted = cleaned.replace(/(\d{3})(\d{1})/, "$1-$2")
    else if (cleaned.length < 11) formatted = cleaned.replace(/(\d{3})(\d{3})(\d{1})/, "$1-$2-$3")
    else formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")

    return formatted
}

export const calculatePhoneNumberCursorPosition = (previousValue: string, newValue: string, selectionStart: number): number => {
    const previousClean = previousValue.replace(/\D/g, '');
    const newClean = newValue.replace(/\D/g, '');
    
    let cursorPos = selectionStart;
    const lengthDiff = newClean.length - previousClean.length;

    cursorPos += lengthDiff;

    // Adjust for dashes
    const previousDashes = (previousValue.slice(0, selectionStart).match(/-/g) || []).length;
    const newDashes = (newValue.slice(0, cursorPos).match(/-/g) || []).length;
    cursorPos += newDashes - previousDashes;

    return Math.max(0, Math.min(cursorPos, newValue.length));
};

export const phoneNumberAutoFormat2 = (countryCode: string,areaCode: string,localNumber: string,extension: string): string => {
    return (countryCode?countryCode+"-":"") + (areaCode?areaCode+"-":"")+(localNumber?localNumber.replace(/(\d{3})(\d{1})/, "$1-$2"):"")+(extension?"x"+extension:"")
}
